import React, { useState, useEffect, useContext } from 'react';
import {
  FaUser,
  FaEnvelope,
  FaPhone,
  FaCalendarAlt,
  FaPaperPlane,
  FaHeart,
  FaHandsHelping
} from 'react-icons/fa';
import '../../assets/css/student/home/Volunteer.css';
import AppContext from "../../context/AppContext";

const Volunteer = () => {
  const { baseUrl, regExpChecker } = useContext(AppContext);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [date, setDate] = useState("");
  const [message, setMessage] = useState("");

  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [dateError, setDateError] = useState("");
  const [messageError, setMessageError] = useState("");

  const [showSuccess, setShowSuccess] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Trigger animations on component mount
    setIsVisible(true);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Show success message
    setShowSuccess(true);

   

    // Hide success message after 5 seconds
    setTimeout(() => {
      setShowSuccess(false);
    }, 5000);
  };

  return (
    <section className="volunteer-section">
      {/* Animated Background Elements */}
      <div className="background-animation">
        <div className="floating-shape shape-1"></div>
        <div className="floating-shape shape-2"></div>
        <div className="floating-shape shape-3"></div>
        <div className="floating-shape shape-4"></div>
        <div className="floating-shape shape-5"></div>
      </div>

      <div className="volunteer-container">
        {/* Left Content Section */}
        <div className={`volunteer-content ${isVisible ? 'slide-in-left' : ''}`}>
          <div className="content-header">
            <FaHandsHelping className="header-icon" />
            <p className="volunteer-subtitle">Our Volunteer</p>
          </div>

          <h1 className="volunteer-title">
            BECOME A <br />
            <span className="highlight-text">VOLUNTEER</span>
          </h1>

          <p className="volunteer-description">
            Join our community and make a real difference in students' lives.
            Help us provide education support, supplies, and opportunities to
            those who need it most.
          </p>

          <div className="impact-stats">
            <div className="stat-item">
              <FaHeart className="stat-icon" />
              <div className="stat-content">
                <h3>1000+</h3>
                <p>Lives Impacted</p>
              </div>
            </div>
            <div className="stat-item">
              <FaHandsHelping className="stat-icon" />
              <div className="stat-content">
                <h3>500+</h3>
                <p>Active Volunteers</p>
              </div>
            </div>
          </div>
        </div>

        {/* Right Form Section */}
        <div className={`volunteer-form-wrapper ${isVisible ? 'slide-in-right' : ''}`}>
          <div className="form-card">
            <h2 className="form-title">Your Name</h2>

            <form onSubmit={handleSubmit} className="volunteer-form">
              {/* Name Input */}
              <div className="input-group">
                <FaUser className="input-icon" />
                <input
                  type="text"
                  placeholder="Your Name"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                    setNameError(regExpChecker("username", e.target.value));
                  }}
                  className="form-input"
                />
                <p className="error-text">{nameError}</p>
              </div>

              {/* Email Input */}
              <div className="input-group">
                <FaEnvelope className="input-icon" />
                <input
                  type="email"
                  placeholder="Email Address"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setEmailError(regExpChecker("email", e.target.value));
                  }}

                  className="form-input"
                />
                <p style={{ color: "red" }}>{emailError}</p>
              </div>

              {/* Phone Input */}
              <div className="input-group">
                <FaPhone className="input-icon" />
                <input
                  type="tel"
                  placeholder="Phone Number"
                  Value={phone}
                  onChange={(e) => {
                    setPhone(e.target.value);
                    setPhoneError(regExpChecker("phone", e.target.value));
                  }}

                  className="form-input"
                />
                <p style={{ color: "red", fontSize: "12px" }}>{phoneError}</p>
              </div>

              {/* Date Input */}
              <div className="input-group date-input-group">
                <FaCalendarAlt className="input-icon" />
                <input
                  type="date"
                  placeholder="dd/mm/yyyy"
                  name="date"
                  value={date}
                  onChange={(e) => {
                    const value = e.target.value;
                    setDate(value);
                    setDateError(value ? "" : "Date is required");
                  }}

                  className="form-input date-input"
                />
                <p className="error-text">{dateError}</p>
              </div>

              {/* Message Input */}
              <div className="input-group">
                <textarea
                  name="message"
                  placeholder="Write Your Message"
                  value={message}
                  onChange={(e) => {
                    const value = e.target.value;
                    setMessage(value);
                    setMessageError(
                      value.length >= 10 ? "" : "Message must be at least 10 characters"
                    );
                  }}

                  className="form-textarea"
                  rows="3"
                />
                <p className="error-text">{messageError}</p>
              </div>

              {/* Submit Button */}
              <button type="submit" className="submit-btn">
                <span>SEND US A MESSAGE</span>
                <FaPaperPlane className="btn-icon" />
              </button>
            </form>

            {/* Success Message */}
            {showSuccess && (
              <div className="success-message fade-in">
                <FaHeart className="success-icon" />
                <p>Thank you for volunteering! We'll contact you soon.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Volunteer;